import React, { ReactElement } from "react";
import { useSelector } from "react-redux";

import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import ClickToCopy from "components/shared/clipboardCopy/ClickToCopy";
import ServerStatus from "components/shared/status/ServerStatus";

import { getBaremetalDetails } from "redux/selectors/baremetalSelector";

const BaremetalRecapBox = (): ReactElement => {
 const baremetal = useSelector(getBaremetalDetails);

 return (
  <Paper elevation={1} sx={{ borderRadius: "5px" }}>
   <Stack spacing={1} p={2}>
    <Stack direction="row" alignItems="center" textAlign="left">
     {baremetal?.service_status && <ServerStatus status={baremetal?.service_status} />}
     <Typography fontWeight="bold" variant="unboundedTitle" fontSize={14} ml={1}>
      {baremetal?.server_name} [{baremetal?.product}]
     </Typography>
    </Stack>
    <Stack direction="row" alignItems="center">
     <Typography variant="extraSmall" fontWeight="bold">
      IPv4:
     </Typography>
     <Typography variant="extraSmall" px={0.5}>
      {baremetal?.server_ip}
     </Typography>
     <ClickToCopy text={baremetal?.server_ip || ""} />
    </Stack>
    <Stack direction="row" alignItems="center">
     <Typography variant="extraSmall" fontWeight="bold">
      IPv6 NET:
     </Typography>
     <Typography variant="extraSmall" px={0.5}>
      {baremetal?.server_ipv6_net}
     </Typography>
     <ClickToCopy text={baremetal?.server_ipv6_net || ""} />
    </Stack>
   </Stack>
  </Paper>
 );
};

export default BaremetalRecapBox;
